/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_AssetInputs */

const en_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading Asset`)
};

const es_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando recurso`)
};

const fr_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la ressource`)
};

const de_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset wird geladen`)
};

const ja_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットを読み込み中`)
};

const zh_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载资产中`)
};

const ar_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاري تحميل الأصل`)
};

const id_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat Aset`)
};

const it_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento Risorsa`)
};

const ru_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка ресурса`)
};

const pt_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando Recurso`)
};

const ko_loading_asset = /** @type {(inputs: Loading_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 로딩 중`)
};

/**
* | output |
* | --- |
* | "Loading Asset" |
*
* @param {Loading_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const loading_asset = /** @type {((inputs?: Loading_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loading_asset(inputs)
	if (locale === "es") return es_loading_asset(inputs)
	if (locale === "fr") return fr_loading_asset(inputs)
	if (locale === "de") return de_loading_asset(inputs)
	if (locale === "ja") return ja_loading_asset(inputs)
	if (locale === "zh") return zh_loading_asset(inputs)
	if (locale === "ar") return ar_loading_asset(inputs)
	if (locale === "id") return id_loading_asset(inputs)
	if (locale === "it") return it_loading_asset(inputs)
	if (locale === "ru") return ru_loading_asset(inputs)
	if (locale === "pt") return pt_loading_asset(inputs)
	return ko_loading_asset(inputs)
});